import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { TabsStyle } from '@website-builder/widgets/tabs/model/tabs-style';
import { TabsNavigationStyle } from '@website-builder/widgets/tabs/model/tabs-navigation-style';
import { TabsTitleStyle } from '@website-builder/widgets/tabs/model/tabs-title-style';
import { TabsSubtitleStyle } from '@website-builder/widgets/tabs/model/tabs-subtitle-style';
import { TabsImageStyle } from '@website-builder/widgets/tabs/model/tabs-image-style';
import { TabsButtonStyle } from '@website-builder/widgets/tabs/model/tabs-button-style';
import { TabsContentStyle } from '@website-builder/widgets/tabs/model/tabs-content-style';
import { TabElement } from '@website-builder/widgets/tabs/tab-element';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class TabsWidget extends BaseMultipleWidget<TabElement, TabsStyle> {
  readonly type = BuilderElementType.Tabs;
  elements: TabElement[] = [
    new TabElement('assets/images/builder/placeholders/mountain.png'),
    new TabElement('assets/images/builder/placeholders/cityscape.png'),
    new TabElement('assets/images/builder/placeholders/cityview.png'),
  ];
  style: TabsStyle = new TabsStyle();
  navStyle: TabsNavigationStyle = new TabsNavigationStyle();
  animation = 'uk-animation-fade';
  matchHeight = true;
  titleStyle: TabsTitleStyle = new TabsTitleStyle();
  subtitleStyle: TabsSubtitleStyle = new TabsSubtitleStyle();
  imageStyle: TabsImageStyle = new TabsImageStyle();
  buttonStyle: TabsButtonStyle = new TabsButtonStyle();
  contentStyle: TabsContentStyle = new TabsContentStyle();

  static normalizeInPlace(widget: TabsWidget): TabsWidget {
    const pureWidget = new TabsWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.elements = (widget.elements ?? pureWidget.elements).map(element => TabElement.normalizeInPlace(element));
    widget.animation = widget.animation ?? pureWidget.animation;
    widget.matchHeight = widget.matchHeight ?? pureWidget.matchHeight;

    widget.titleStyle = TabsTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = TabsSubtitleStyle.normalize(widget.subtitleStyle);
    widget.imageStyle = TabsImageStyle.normalize(widget.imageStyle);
    widget.buttonStyle = TabsButtonStyle.normalize(widget.buttonStyle);
    widget.contentStyle = TabsContentStyle.normalize(widget.contentStyle);

    return widget;
  }
}
